// Shared device/scene grid sizing, scroll paging and observer lifecycle.
export default {
 data() {return {deviceColumns:1,hasDeviceOverflow:false,hasDeviceScrolled:false,devicePageAttempt:null}},
 watch:{card:{immediate:true,handler(){this.$nextTick(this.resizeDeviceGroup)}}},
  mounted() {
    if (!['device_cards', 'scene_cards'].includes(this.card.type)) return
    this.resizeDeviceGroup()
    if (typeof ResizeObserver !== 'undefined') {
      this._deviceResize = new ResizeObserver(this.resizeDeviceGroup)
      this._deviceResize.observe(this.$el)
      if (this.$refs.deviceScroll) this._deviceResize.observe(this.$refs.deviceScroll)
      if (this.$refs.deviceGrid) this._deviceResize.observe(this.$refs.deviceGrid)
    } else window.addEventListener('resize', this.resizeDeviceGroup)
  },
  updated() { this.measureDeviceOverflow() },
  beforeDestroy() {
    if (this._deviceResize) this._deviceResize.disconnect()
    window.removeEventListener('resize', this.resizeDeviceGroup)
  },
 methods:{    measureDeviceOverflow() {
      const box = this.$refs && this.$refs.deviceScroll
      const overflow = !!box && box.scrollHeight > box.clientHeight + 1
      if (this.hasDeviceOverflow !== overflow) this.hasDeviceOverflow = overflow
      const scrolled = overflow && box.scrollTop > 1
      if (this.hasDeviceScrolled !== scrolled) this.hasDeviceScrolled = scrolled
    },
    resizeDeviceGroup() {
      if (!['device_cards', 'scene_cards'].includes(this.card.type) || !this.$el) return
      // Read the shared scroll surface's actual content width, including native scrollbar space.
      const scroll = this.$refs.deviceScroll
      if (!scroll) return
      const style = getComputedStyle(scroll)
      const available = scroll.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)
      if (available <= 0) return
      this.deviceColumns = Math.max(1, Math.min(3, this.card.items.length, Math.floor((available + 10) / 180)))
      this.$nextTick(this.measureDeviceOverflow)
    },
    devicePageKey() { return [this.card.id, this.card.nextCursor, this.card.items.length].join('|') },
    requestDevicePage(retry = false) {
      if (this.busy || !this.card.hasMore) return
      const key = this.devicePageKey()
      // 同一游标仅自动请求一次；失败由用户重试，避免滚动事件引发重复请求。
      if (!retry && this.devicePageAttempt === key) return
      this.devicePageAttempt = key
      this.$emit('page', this.card)
    },
    loadDevicesOnScroll() {
      const box = this.$refs.deviceScroll
      if (!this.busy && this.card.hasMore && box && box.scrollHeight > box.clientHeight && box.scrollHeight - box.scrollTop - box.clientHeight < 16)
        this.requestDevicePage()
    }}
}
